module.exports = __webpack_public_path__ + "static/media/Claim-icon-2.f0b80555.svg";